import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Layout, Collapse, Typography, Row, Col, Button } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { StoreContext } from '../store/index';
import AddPlacesModal from './addPlacesModal';
import AddTokensModal from './addTokensModal';

const { Content } = Layout;
const { Panel } = Collapse;
const { Title, Paragraph, Text } = Typography;

const AdminPanel = () => {
  const store = useContext(StoreContext);
  const {
    user: [user],
  } = store;
  const navigate = useNavigate();
  const { formatMessage } = useIntl();

  const [showAddTokensModal, setShowAddTokensModal] = useState(false);

  const [showAddPlacesModal, setShowAddPlacesModal] = useState(false);

  return (
    <Layout>
      {showAddTokensModal && (
        <AddTokensModal
          visible={showAddTokensModal}
          onClose={() => setShowAddTokensModal(false)}
        />
      )}
      {showAddPlacesModal && (
        <AddPlacesModal
          visible={showAddPlacesModal}
          onClose={() => setShowAddPlacesModal(false)}
        />
      )}
      <Content style={{ padding: '0 5px 0 5px' }}>
        <PageHeader
          className="site-page-header"
          onBack={user.isOwner ? () => navigate('/') : null}
          title={
            <div
              style={{
                backgroundColor: 'white',
                padding: '10px 20px',
                borderRadius: '5px',
              }}>
              Admin Panel
            </div>
          }
        />
        <Row justify="center">
          <Col span={24}>
            <Collapse
              style={{
                backgroundColor: 'white',
              }}
              defaultactivekey={['1']}>
              <Panel header="Actions" key="1">
                <Row>
                  <Button
                    className="width100"
                    type="primary"
                    onClick={() => setShowAddTokensModal(true)}>
                    {formatMessage({ id: 'admin.panel.add.tokens.button' })}
                  </Button>
                </Row>
                <Row style={{ marginTop: '4px' }}>
                  <Button
                    className="width100"
                    type="primary"
                    onClick={() => setShowAddPlacesModal(true)}>
                    {formatMessage({ id: 'admin.panel.add.places.button' })}
                  </Button>
                </Row>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default AdminPanel;
